// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "2c5582419ca33865","460": "a8beeb7184ef6fbb","917": "a0325a34130f3b18","985": "dff69f2e82c175a1",}[chunkId] + ".chunk.js"
}